import React from 'react';
import { css } from '@emotion/react';
import { UnifiedAccountTagContainer } from '../UnifiedAccountTagContainer';

const primaryContentStyles = css({
  backgroundColor: '#FFFFFF',
  color: '#172B4D',
  border: '1px solid #091E4224',
});

export const UnifiedAccountTagLinked: React.FC = () => (
  <UnifiedAccountTagContainer>
    <div css={[primaryContentStyles, baseContentStyles]}>LINKED</div>
  </UnifiedAccountTagContainer>
);

const baseContentStyles = css({
  fontFamily: 'Charlie Text',
  height: '28px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 8px',
  boxSizing: 'border-box',
  fontSize: '12px',
  fontWeight: '600',
  borderRadius: '4px',
});
